import Delete from "@mui/icons-material/Delete";
import Grid2 from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import React, { ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import FormTextField from "../../Common/FormTextField";
import { getFieldPath } from "../../Common/SchemaUtils";

type HtmlEvent = ChangeEvent<HTMLTextAreaElement | HTMLInputElement>;

const IntFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
  remove?: Function;
}> = ({ extractionId, extractionPath, label, remove }) => {
  const { control } = useFormContext();
  const handleChange = (e: HtmlEvent, fieldOnChange: (e: any) => void) =>
    fieldOnChange(Number(e.target.value.replace(/\D/, "")));
  return (
    <Grid2 container spacing={2} sx={{ alignItems: "center" }}>
      <Grid2 size={remove !== undefined ? 11 : 12}>
        <FormTextField
          size="small"
          label={label}
          key={getFieldPath([extractionId, extractionPath])}
          name={`extraction.${getFieldPath([
            extractionId,
            "value",
            extractionPath,
          ])}`}
          handleChange={handleChange}
          control={control}
          type="number"
          rules={{ valueAsNumber: true }}
        />
      </Grid2>
      {remove !== undefined && (
        <Grid2 size={1} sx={{ textAlign: "right" }}>
          <IconButton
            onClick={() => {
              remove();
            }}
            className="rounded-full"
            size="small"
          >
            <Delete color="error" />
          </IconButton>
        </Grid2>
      )}
    </Grid2>
  );
};

export default IntFormFields;
